export default __webpack_public_path__ + "static/media/include_10@3x.fe96ec93.jpg";